import { render, staticRenderFns } from "./page-ad-card-customize.vue?vue&type=template&id=2d352a32&"
import script from "./page-ad-card-customize.vue?vue&type=script&lang=js&"
export * from "./page-ad-card-customize.vue?vue&type=script&lang=js&"
import style0 from "./page-ad-card-customize.vue?vue&type=style&index=0&id=2d352a32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports